"use client";

import * as motion from "motion/react-client";

const draw = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i: number) => {
    const delay = i * 0.2;
    return {
      pathLength: 1,
      opacity: 1,
      transition: {
        pathLength: { delay, type: "spring", duration: 2.5, bounce: 0 },
        opacity: { delay, duration: 0.02 },
      },
    };
  },
};

export default function AnimatedSVG() {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-80 0 400 100"
      initial="hidden"
      animate="visible"
      width={600}
      height={600}
      style={image}
    >
      {/* Lettre M */}
      <motion.path
        d="M59.51.4h21.79l37.07,81.07L152.18.4h23.59v1.77c-1.05,0-2.25.16-3.59.47-1.35.31-2.64.88-3.88,1.71-1.26.86-2.32,1.98-3.09,3.3-.88,1.61-1.31,3.42-1.23,5.25v73.87c0,2.05.41,3.76,1.23,5.13.76,1.32,1.82,2.45,3.09,3.3,1.23.83,2.53,1.42,3.88,1.77s2.55.53,3.59.53v1.77h-35.27v-1.77c1.05,0,2.25-.18,3.6-.53s2.64-.94,3.88-1.77c1.26-.86,2.31-1.99,3.09-3.3.87-1.57,1.3-3.34,1.24-5.13V8.89l-38.3,92.05L74.57,14.44v66.91c0,3.54.41,6.37,1.23,8.5.64,1.84,1.67,3.51,3.03,4.9,1.2,1.14,2.47,1.89,3.82,2.24s2.55.53,3.6.53v1.77h-26.73v-1.77c1.05,0,2.25-.18,3.6-.53s2.62-1.1,3.82-2.24c1.36-1.39,2.39-3.06,3.03-4.9.82-2.12,1.23-4.96,1.23-8.5V12.91c0-2.12-.41-3.87-1.23-5.25-.76-1.31-1.79-2.43-3.03-3.3-1.15-.81-2.45-1.39-3.82-1.71-1.18-.29-2.39-.45-3.6-.47V.41h0Z"
        stroke="#e6e7e4"
        variants={draw}
        custom={1}
        style={shape}
        fill="none"
      />
      {/* Lettre R */}
      <motion.path
        d="M93.93,91.02c-5.99.43-10.96.28-14.92-.44-3.95-.73-7.23-1.85-9.84-3.39-2.42-1.36-4.52-3.23-6.16-5.48-1.52-2.15-2.83-4.45-3.91-6.85-1.12-2.47-2.17-4.97-3.15-7.5-1-2.58-2.25-5.05-3.73-7.38-1.59-2.47-3.55-4.69-5.8-6.57-2.37-2.02-5.47-3.67-9.3-4.96-1.22-.42-2.44-.86-3.64-1.33-1.17-.46-2.02-.9-2.56-1.33v-2.26c4.07,2.26,7.98,3.43,11.73,3.51,3.74.08,7.05-.56,9.93-1.93,2.78-1.29,5.16-3.31,6.87-5.85,1.71-2.53,2.56-5.32,2.56-8.39s-.58-5.7-1.75-7.9c-1.12-2.13-2.68-4-4.58-5.48-1.91-1.46-4.05-2.6-6.34-3.35-4.48-1.5-9.22-2.06-13.93-1.65-1.87.16-3.71.53-5.48,1.13v56.52c0,1.4.33,2.57.99,3.51.64.92,1.47,1.69,2.43,2.26.96.56,1.98.95,3.05,1.17,1.08.22,2.04.32,2.88.32v1.21H11.24v-1.21c.84,0,1.78-.11,2.83-.32,1.07-.22,2.11-.61,3.05-1.17.98-.56,1.83-1.33,2.47-2.26.66-.94.99-2.11.99-3.51V19.91c0-1.4-.33-2.57-.99-3.51-.65-.93-1.49-1.7-2.47-2.26-.99-.56-2.01-.95-3.05-1.17-.93-.2-1.88-.31-2.83-.32v-1.21c2.34,0,4.52-.07,6.56-.2s4.04-.29,6.02-.48c1.98-.19,4.01-.35,6.11-.48s4.43-.2,7.01-.2c3.83,0,7.8.35,11.91,1.05,4.1.7,7.85,1.85,11.23,3.47,3.23,1.5,6.09,3.7,8.36,6.45,2.19,2.69,3.28,6.02,3.28,10,0,2.37-.53,4.52-1.57,6.45-1.07,1.95-2.5,3.68-4.22,5.08-1.87,1.51-3.95,2.76-6.16,3.71-2.4,1.04-4.9,1.85-7.46,2.42,2.39.7,4.39,1.83,5.98,3.39,1.61,1.59,2.96,3.43,4,5.44,1.13,2.18,2.09,4.44,2.88,6.77.84,2.45,1.74,4.89,2.7,7.34.96,2.45,2.07,4.8,3.32,7.06,1.27,2.26,2.91,4.3,4.85,6.01,2.14,1.84,4.61,3.26,7.28,4.19,2.88,1.05,6.41,1.57,10.6,1.57v.56-.02Z"
        stroke="#e6e7e4"
        variants={draw}
        custom={2}
        style={shape}
        fill="none"
      />
      {/* Lettre G */}
      <motion.path
        d="M206.86,44.44h27.68v1.21c-.78,0-1.66.11-2.65.32-.99.22-1.93.56-2.83,1.05-.91.49-1.72,1.15-2.38,1.94-.72.87-1.17,1.94-1.3,3.06h.09l-.18,4.52v23.62h-1.26l-5.3-4.11c-3.22,1.78-6.66,3.13-10.24,3.99-4.12.98-8.34,1.45-12.58,1.41-6.71,0-12.58-.99-17.61-2.98-4.67-1.76-8.95-4.43-12.58-7.86-3.27-3.12-5.84-6.9-7.55-11.09-3.35-8.16-3.35-17.32,0-25.48,1.71-4.19,4.28-7.96,7.55-11.09,3.63-3.43,7.91-6.1,12.58-7.86,5.03-1.99,10.9-2.98,17.61-2.98,2.69,0,5.14.16,7.32.48,2.19.32,4.12.69,5.8,1.09,1.68.4,3.11.78,4.31,1.13,1.2.35,2.19.52,2.97.52s1.32-.23,1.62-.69c.3-.46.42-.98.36-1.57h1.26l5.57,22.01-1.53.08c-3.07-5.82-7.51-10.82-12.94-14.55-2.69-1.85-5.62-3.32-8.72-4.35-3.1-1.04-6.34-1.58-9.61-1.57-4.13,0-7.95.71-11.46,2.14-3.38,1.34-6.46,3.33-9.08,5.85-2.55,2.47-4.58,5.41-5.98,8.67-1.44,3.31-2.16,6.84-2.16,10.6s.66,7.31,1.98,10.97c1.32,3.66,3.13,7.11,5.39,10.28,2.28,3.2,5.02,6.06,8.13,8.47,3.07,2.41,6.51,4.29,10.2,5.56,3.69,1.27,7.6,1.8,11.5,1.57,4.01-.21,8.06-1.4,12.13-3.55,1.26-.7,2.28-1.4,3.06-2.1v-20.16c0-1.45-.33-2.65-.99-3.59-.63-.91-1.44-1.68-2.38-2.26-.92-.55-1.92-.95-2.97-1.17-.93-.2-1.88-.31-2.83-.32v-1.21h0Z"
        stroke="#e6e7e4"
        variants={draw}
        custom={3}
        style={shape}
        fill="none"
      />
    </motion.svg>
  );
}

/**
 * ==============   Styles   ================
 */

const image: React.CSSProperties = {
  maxWidth: "100vw",
};

const shape: React.CSSProperties = {
  strokeWidth: 1,
  strokeLinecap: "round",
  fill: "transparent",
};
